import { Button, Typography } from "@commonlibs";
import { RecoverPasswordFormFields, RecoverPasswordFormData } from "./RecoverPasswordFormTab.types";
import useTranslate from "ui/locale/hooks/useTranslate";
import TextField from "ui/common/components/input/TextField/TextField";
import { useState } from "react";
import Form from "ui/common/components/input/Form/Form";
import { useRecoverPassword } from "features/auth/hooks/useRecoverPassword";
import useGoToNextTab from "ui/common/components/navigation/StatefulTabs/hooks/useGoToNextTab";
import useTabsState from "ui/common/components/navigation/StatefulTabs/hooks/useTabsState";
import { RecoverPasswordResponseDto } from "./AuthResponseRecoverPassDto";

interface RecoverPasswordTabState {
    recoveryData?: RecoverPasswordResponseDto;
}

const RecoverPasswordFormTab = (): JSX.Element => {
    const translate = useTranslate();
    const goToNextTab = useGoToNextTab();
    const [identifier, setIdentifier] = useState("");
    const [state, setState] = useTabsState<RecoverPasswordTabState>();

    const handleRecoverPasswordSuccess = () => {
        goToNextTab();
    };

    const { mutate: recoverPassword, isLoading: isRecovering } = useRecoverPassword({
        onSuccess: (data) => {
            setState({ ...state, recoveryData: data });
            handleRecoverPasswordSuccess();
        },
        onError: () => {
            handleRecoverPasswordSuccess();
        },
    });

    const handleSubmit = ({ identifier }: RecoverPasswordFormData) => {
        recoverPassword(Number(identifier));
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Typography variant="body2Light" color="gray.450" textAlign="center">
                {translate("changePasswordInfoText")}
            </Typography>
            <TextField
                name={RecoverPasswordFormFields.IDENTIFIER}
                label={translate("identification")}
                placeholder={translate("identificationLoginPlaceholder")}
                validators={{ number: true, minChars: 6 }}
                required
                value={identifier}
                onChange={setIdentifier}
            />
            <Button type="submit" loading={isRecovering} variant={"primary"}>
                {translate("resetPasswordClean")}
            </Button>
        </Form>
    );
};

export default RecoverPasswordFormTab;
